import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Importing Apiendpoint
import { apiendpoint } from "../../helpers/apiendpoint";

// Importing texts
import TxtInter from "../../01_atoms/text/Inter";

// Importing icons and components
import {
  SrCompIconDone,
  SrCompIconClose,
  SrCompIconEdit,
  SrCompIconDelete,
  SrCompIconExpandMore,
  SrCompIconExpandLess
} from "../../01_atoms/icons";
import TextInputIntRe12Small from "../../01_atoms/textInputs/TextInputIntRe12Small";

import style from "./style";

// Attendee card
const AttendeeCard = ({
  adding,
  org,
  name,
  mobile,
  email,
  userType,
  listingStatus,
  representer,
  eventId,
  type,
  guestId,
  orgId,
  setGuestAdd,
  setFetchMore,
  setSpecialGuestAdd,
  setStartupAdd
}) => {
  const [expanded, setExpanded] = useState(adding);
  const [guestEdit, setGuestEdit] = useState(adding);

  const [orgName, setOrgName] = useState(org);
  const [orgNameEdit, setOrgNameEdit] = useState(false);
  const [guestName, setGuestName] = useState(name);
  const [guestNameEdit, setGuestNameEdit] = useState(false);
  const [guestMobile, setGuestMobile] = useState(mobile);
  const [guestMobileEdit, setGuestMobileEdit] = useState(false);
  const [guestEmail, setGuestEmail] = useState(email);
  const [guestEmailEdit, setGuestEmailEdit] = useState(false);

  const [status, setStatus] = useState(
    userType === "gst"
      ? listingStatus === "Y"
        ? 0
        : -1
      : listingStatus === "co"
      ? 3
      : listingStatus === "re"
      ? 2
      : listingStatus === "do"
      ? 1
      : representer && representer.is_setup === "Y"
      ? 0
      : -1
  );

  const snackbar = (message) => {
    toast(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined
    });
  };

  let jwt = localStorage.getItem("@jwtauth");
  if (!jwt) jwt = "";

  //To update states back after cancel
  const onCancel = () => {
    setOrgName(org);
    setGuestEmail(email);
    setGuestMobile(mobile);
    setGuestName(name);
  };

  // This useEffect is used to change the states after deletion
  useEffect(() => {
    onCancel();
  }, [name]);

  //func to add startup
  const handleStartupAdd = () => {
    let jwt = localStorage.getItem("@jwtauth");
    if (!jwt) jwt = "";

    fetch(`${apiendpoint}/community/inviteMember/${eventId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`
      },
      body: JSON.stringify(
        type === "participant"
          ? {
              org: {
                org_name: orgName,
                org_member: {
                  fname: guestName,
                  email: guestEmail,
                  number: guestMobile
                }
              }
            }
          : type === "guest"
          ? {
              guest: [
                {
                  fname: guestName,
                  email: guestEmail,
                  number: guestMobile
                }
              ]
            }
          : {
              special_guest: [
                {
                  fname: guestName,
                  email: guestEmail,
                  number: guestMobile
                }
              ]
            }
      )
    })
      .then((res) => {
        if (res.ok) return res.json();
        else throw new Error("Unauthorized");
      })
      .then((data) => {
        if (!data.success) {
          snackbar("Attendee's number already exists!");
        } else {
          snackbar("Attendee Added");
        }
        setFetchMore(true);
        setStartupAdd(false);
        setGuestAdd(false);
        setGuestEdit(false);
        setSpecialGuestAdd(false);
      });
  };

  // func for editing startup
  const handleStartupEdit = (mid, oid, type) => {
    if (type === "startup")
      fetch(`${apiendpoint}/event/startups/${oid}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt}`
        },
        body: JSON.stringify({ name: orgName })
      })
        .then((res) => {
          if (res.ok) return res.json();
          else throw new Error("Unauthorized");
        })
        .then((data) => {
          setFetchMore(true);
          // setEventInfoEdit(false);
        });

    // console.log(mid);
    fetch(`${apiendpoint}/event/members/${mid}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`
      },
      body: JSON.stringify({
        fname: guestName,
        phone_no: guestMobile,
        email_id: guestEmail
      })
    })
      .then((res) => {
        if (res.ok) return res.json();
        else throw new Error("Unauthorized");
      })
      .then((data) => {
        snackbar("Attendee updated");
        setFetchMore(true);
        // setEventInfoEdit(false);
      });
    setGuestEdit(false);
  };

  // func to delete
  const handleStartupDel = (sid, type) => {
    fetch(`${apiendpoint}/community/${type}/${sid}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`
      }
    })
      .then((res) => {
        if (res.ok) return res.json();
        else throw new Error("Unauthorized");
      })
      .then((data) => {
        snackbar("Attendee removed");
        setFetchMore(true);
        onCancel();
      });
  };

  const Dot = () => {
    return (
      <div style={style.status}>
        {status >= status ? <div style={style.greenDot}></div> : <div style={style.redDot}></div>}
      </div>
    );
  };

  // Dynamic styling for this component
  const style2 = {
    innerDiv: {
      ...style.innerDiv,
      width: expanded && !guestEdit ? "300px" : "228px"
    }
  };

  return (
    <div style={style.container}>
      <div style={style.outerDiv}>
        <div style={style2.innerDiv}>
          {/* Card title */}
          {guestEdit ? (
            type === "participant" ? (
              // If editing is true and card type is participant
              // Text input for startup's name
              <TextInputIntRe12Small
                type="text"
                name="orgName"
                placeholder={"Startup's name"}
                value={orgName}
                onChange={(e) => {
                  setOrgName(e.target.value);
                }}
                onClick={() => setOrgNameEdit(true)}
              />
            ) : (
              // If editing is true and card type is NOT participant
              // Text input for name
              <TextInputIntRe12Small
                type="text"
                name="guestName"
                placeholder={"Full name"}
                value={guestName}
                onChange={(e) => {
                  setGuestName(e.target.value);
                }}
                onClick={() => setGuestNameEdit(true)}
              />
            )
          ) : type === "participant" ? (
            // If editing is false and card type is participant
            // Text for startup's name
            <div style={style.paddingVert1}>
              <TxtInter size={17.28} weight={600} content={orgName} />
            </div>
          ) : (
            // If editing is false and card type is NOT participant
            // Text for name
            <div style={style.paddingVert1}>
              <TxtInter size={17.28} weight={600} content={guestName} />
            </div>
          )}

          {!guestEdit && (
            <>
              {/* Row of icons */}
              <div style={{ ...style.flexRow, ...style.alignItemsCenter, ...style.gap6 }}>
                {/* Show these icons only if the card is expanded */}
                {expanded && (
                  <>
                    {/* Edit button */}
                    <div onClick={() => setGuestEdit(true)} style={style.icon20}>
                      <SrCompIconEdit />
                    </div>

                    {/* Delete button */}
                    <div
                      style={style.icon20}
                      onClick={() =>
                        type === "participant"
                          ? handleStartupDel(orgId, "startups")
                          : handleStartupDel(guestId, "members")
                      }
                    >
                      <SrCompIconDelete />
                    </div>
                  </>
                )}

                <>
                  {/* Dropdown */}
                  <div
                    onClick={() => {
                      setExpanded(!expanded);
                      setGuestEdit(false);
                    }}
                    style={style.icon20}
                  >
                    {/* Expand or minimize icon based on state */}
                    {!expanded ? <SrCompIconExpandMore /> : <SrCompIconExpandLess />}
                  </div>
                </>
              </div>
            </>
          )}
        </div>

        {/* Show more info if the card is expanded */}
        {expanded && (
          <div style={style.expandedWrap}>
            <div style={style.expandedInnerWrap}>
              {guestEdit ? (
                <>
                  {type === "participant" && (
                    // If editing is true and card type is participant
                    // Text input for startup founder's full name
                    <TextInputIntRe12Small
                      type="text"
                      name="guestName"
                      placeholder={"Startup founder's name"}
                      value={guestName}
                      onChange={(e) => {
                        setGuestName(e.target.value);
                      }}
                      onClick={() => setGuestNameEdit(true)}
                    />
                  )}

                  {/* Text input for mobile number */}
                  <TextInputIntRe12Small
                    type="text"
                    name="guestMobile"
                    placeholder={"Mobile number"}
                    value={guestMobile}
                    onChange={(e) => {
                      setGuestMobile(e.target.value);
                    }}
                    onClick={() => setGuestMobileEdit(true)}
                  />

                  {/* Text input for email id */}
                  <TextInputIntRe12Small
                    type="text"
                    name="guestEmail"
                    placeholder={"Email id"}
                    value={guestEmail}
                    onChange={(e) => {
                      setGuestEmail(e.target.value);
                    }}
                    onClick={() => setGuestEmailEdit(true)}
                  />
                </>
              ) : (
                <>
                  {/* If editing is true and card type is participant */}
                  {/* Text for startup founder's full name */}
                  {type === "participant" && (
                    <div style={style.paddingVert1}>
                      <TxtInter size={17.28} weight={300} content={guestName} />
                    </div>
                  )}

                  {/* Text for mobile number */}
                  <div style={style.paddingVert1}>
                    <TxtInter size={17.28} weight={300} content={guestMobile} />
                  </div>

                  {/* Text for email id */}
                  <div style={style.paddingVert1}>
                    <TxtInter size={17.28} weight={300} content={guestEmail} />
                  </div>
                </>
              )}
            </div>

            {guestEdit ? (
              <>
                {/* Buttons for reminder */}
                <div style={style.guestEditOuterWrap}>
                  {guestEdit && (
                    <>
                      <div
                        style={style.guestEditInnerWrap}
                        onClick={() => {
                          if (adding) {
                            handleStartupAdd();
                          } else {
                            type === "participant"
                              ? handleStartupEdit(guestId, orgId, "startup")
                              : handleStartupEdit(guestId);
                          }
                        }}
                      >
                        <TxtInter size={12.96} weight={400} content={"SAVE"} />
                        <SrCompIconDone />
                      </div>

                      <div
                        onClick={() => {
                          // setFetchMore(true);
                          if (adding) {
                            setStartupAdd(false);
                            setGuestAdd(false);
                            setSpecialGuestAdd(false);
                          } else setGuestEdit(false);
                          onCancel();
                        }}
                        style={style.cancelBtnWrap}
                      >
                        <TxtInter size={12.96} weight={400} content={"CANCEL"} />
                        <SrCompIconClose />
                      </div>
                    </>
                  )}
                </div>
              </>
            ) : (
              <>
                {/* {!guestEdit && (
                  <div
                    style={{
                      ...style.flexRow,
                      ...style.alignItemsCenter,
                      ...style.gap3,
                      padding: "3px 6px 3px 9px",
                      ...style.surfaceBlurNote,
                      ...style.borderRadius6,
                      ...style.clickable
                    }}
                  >
                    <SrRefTextIntRe09 content={"SEND INVITE"} />
                    <SrCompIconDone />
                  </div>
                )} */}
              </>
            )}
          </div>
        )}
      </div>

      {type === "participant" ? (
        <div style={style.flexRow}>
          <div style={style.status}>
            <div style={style.greenDot}></div>
          </div>
          <Dot status={0} />
          <Dot status={1} />
          <Dot status={2} />
          <Dot status={3} />
        </div>
      ) : (
        <div style={style.flexRow}>
          <div style={style.status}>
            <div style={style.greenDot}></div>
          </div>
          <Dot status={0} />
        </div>
      )}
    </div>
  );
};

export default AttendeeCard;
